import PlanItem from './PlanItem';

import {
  TableContainer,
  RowData,
  LabelContainer,
  InfoContainer,
} from './styled/ContractedPlan.styled';

interface PlanTableProps {
  planInfo?: Array<PlanItem>;
  multiRowHover?: boolean;
}

const defaultProps = {
  planInfo: [],
  multiRowHover: false,
};

const PlanTable = ({
  planInfo = defaultProps.planInfo,
  multiRowHover = defaultProps.multiRowHover,
}: PlanTableProps) => {
  const rowMouseOver = (key: string) => {
    if (multiRowHover) {
      document.querySelectorAll(`.plan-row-${key}`).forEach((el) => {
        el.classList.add('plan-row-hover');
      });
    }
  };

  const rowMouseOut = (key: string) => {
    if (multiRowHover) {
      document.querySelectorAll(`.plan-row-${key}`).forEach((el) => {
        el.classList.remove('plan-row-hover');
      });
    }
  };

  return (
    <TableContainer>
      <tbody>
        {planInfo.map((item) => (
          <RowData
            key={item.planKey}
            group={item.group}
            onMouseOver={() => rowMouseOver(item.planKey)}
            onMouseOut={() => rowMouseOut(item.planKey)}
            className={multiRowHover ? `plan-row-${item.planKey}` : ''}
          >
            <LabelContainer>
              {item.label}
            </LabelContainer>
            <InfoContainer>
              {item.getFullInfo()}
            </InfoContainer>
          </RowData>
        ))}
      </tbody>
    </TableContainer>
  );
};

export default PlanTable;
